import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { interval } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  year: number = new Date().getFullYear();
  view: number = parseFloat(this.localStorageService.getItem("view"))
  constructor(private localStorageService: LocalStorageService,public commonService : CommonService) { }

  ngOnInit() {
    interval(90000).subscribe(x => {
      if(!window.location.href.includes("login")){
        this.commonService.getData("api/get_cp_year_and_view").subscribe((responseResult: any) => {
          if (responseResult.Data != null) {
            this.localStorageService.setItem("YearCP", responseResult.Data.Table[0]["year"]);
            this.localStorageService.setItem("LastUpdateCP", responseResult.Data.Table[0]["last_user_update"]);
            this.view = parseFloat(responseResult.Data1);
          }
      });
      }
  });
  }
}
